export default {
  coverBoxStyle: {
    width: "90%",
    borderRadius: 8,
    boxShadow: "0 1px 20px 0 rgba(199, 215, 221, 0.67)",
    backgroundColor: "#fff",
    paddingLeft: "24px",
    paddingRight: "24px",
    paddingTop: "20px",
    margin: "auto",
    position: "relative" as "relative",
    top: "-100px",
  },

  coverBoxTitle: {
    fontSize: "18px",
    fontWeight: 500,
    color: "#222",
    marginBottom: "16px",
    textAlign: "center" as "center",
    paddingBottom: "16px",
    borderBottom: "1px solid #0003",
    // whiteSpace: "nowrap" as "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontFamily: "PingFangSC-Medium",
  },

  coverSignWrapper: {
    marginBottom: "22px",
  },

  coverSignTitle: {
    color: "#222",
    fontSize: "14px",
    fontWeight: 400,
  },

  coverSignTime: {
    color: "#4d4d4d",
    fontSize: "16px",
  },

  coverJoinWrapper: {},

  coverPortraitWrapper: {
    marginLeft: "10px",
    height: "32px",
  },

  coverPortrait: {
    width: "28px",
    height: "28px",
    padding: "2px",
    backgroundColor: "#fff",
    borderRadius: "16px",
    boxShadow: "rgb(228, 228, 228) 0px 1px 1px",
    marginLeft: "-10px",
  },

  coverJoinNum: {
    color: "#4d4d4d",
    fontSize: "14px",
  },

  ruleWrapper: {
    paddingLeft: "16px",
    paddingRight: "16px",
  },

  ruleTitle: {
    marginTop: "25px",
    paddingTop: "11px", // 有白色底边的部分
    lineHeight: "27px",
    backgroundColor: "white",
    textAlign: "center" as "center",
    color: "#222",
    fontSize: "16px",
    fontWeight: "bold" as "bold",
  },

  ruleTime: {
    marginTop: "4px",
    marginBottom: "4px",
    lineHeight: "16px",
    textAlign: "center" as "center",
    color: "#00C274",
    fontSize: "12px",
    fontWeight: "bold" as "bold",
  },

  rule: {
    color: "#7a7a7a",
    fontSize: "14px",
  },

  signButton: {
    position: "fixed" as "fixed",
    width: "100%",
    left: 0,
    bottom: 0,
    display: "block",
    height: "50px",
    backgroundColor: "#00bc71",
    textAlign: "center" as "center",
    lineHeight: "50px",
    color: "#fff",
    textDecoration: "none",
    fontWeight: 600,
    fontSize: "16px",
  },

  awardItem: {
    width: "100%",
    height: "85px",
    paddingLeft: "108px",
    paddingRight: "16px",
    marginBottom: "13px",
    position: "relative" as "relative",
  },
  awardPic: {
    width: "80px",
    height: "80px",
    position: "absolute" as "absolute",
    top: 0,
    left: "16px",
  },
  awardDescWrapper: {
    height: "85px",
    // paddingTop: '15px'
  },
  awardName: {
    fontSize: "14px",
    color: "#222",
    fontWeight: 600,
    lineHeight: "85px",
  },
  awardDesc: {
    fontSize: "12px",
    color: "#999",
  },

  leftTimeWrapper: {
    textAlign: "center" as "center",
    color: "#555",
    fontSize: "16px",
  },

  progressWrapper: {
    marginTop: "20px",
  },

  finishWrapper: {},

  finishNum: {
    float: "left" as "left",
    color: "#808080",
    fontSize: "14px",
  },

  goalWrapper: {
    fontSize: "14px",
    color: "#808080",
    float: "right" as "right",
  },

  leftNumWrapper: {},

  leftNum: {
    color: "#00bc71",
    fontSize: "40px",
    // fontWeight: 900,
    margin: "0 5px",
    fontFamily: "VeneerCleanSoft",
    verticalAlign: "sub",
  },

  goalNum: {
    color: "#00bc71",
    marginLeft: "4px",
  },

  viewDetailWrapper: {
    fontSize: "13px",
    color: "#808080",
    marginTop: "30px",
    textAlign: "center" as "center",
  },
  goalItem: {
    width: "100%",
    height: "50px",
    lineHeight: "50px",
    textAlign: "center" as "center",
    borderBottom: "1px solid #eee",
    fontSize: "15px",
    color: "#222",
  },

  feedContainer: {
    paddingRight: "13px",
  },
  feedItem: {
    width: "calc(50% - 13px)",
    float: "left" as "left",
    marginBottom: "15px",
    marginLeft: "13px",
    textDecoration: "none",
    display: "block",
  },
  feedImg: {
    width: "100%",
    height: "140px",
    borderRadius: "4px",
    marginBottom: "8px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
  },
  feedUserWrapper: {},
  feedUser: {
    float: "left" as "left",
    width: "50%",
    overflow: "hidden",
  },
  feedPortrait: {
    display: "inline-block",
    width: "24px",
    height: "24px",
    borderRadius: "12px",
    verticalAlign: "middle",
    marginRight: "4px",
  },
  feedNick: {
    fontSize: "12px",
    color: "#808080",
    fontWeight: 500,
    display: "inline-block",
    width: "calc(100% - 30px)",
    overflow: "hidden",
    whiteSpace: "nowrap" as "nowrap",
    textOverflow: "ellipsis",
    position: "relative" as "relative",
    top: "3px",
  },
  feedTime: {
    fontSize: "12px",
    color: "#808080",
    lineHeight: "26px",
    fontWeight: 500,
    float: "right" as "right",
  },

  routeItem: {
    paddingTop: "16px",
    paddingBottom: "16px",
  },
  routePic: {
    width: "85px",
    height: "85px",
    float: "left" as "left",
    marginRight: "16px",
  },

  routeMain: {},
  routeStartTime: {
    fontSize: "12px",
    color: "#7a7a7a",
    letterSpacing: "0.2px",
  },
  totalLengthWrapper: {
    fontSize: "15px",
    fontWeight: 500,
    color: "#2e4254",
  },
  totalLength: {
    color: "#2e4254",
    // fontWeight: 500,
    fontFamily: "VeneerCleanSoft",
    fontSize: "40px",
    marginRight: "5px",
  },
  routeTime: {
    color: "#7a7a7a",
    fontSize: "12px",
  },
  buttonWrapper: {
    width: "100%",
    height: "50px",
    borderBottom: "1px solid #eee",
    paddingLeft: "16px",
    paddingRight: "16px",
  },
  cancelButton: {
    width: "50%",
    float: "left" as "left",
    height: "50px",
    lineHeight: "50px",
    fontSize: "15px",
    color: "#575757",
  },
  confirmButton: {
    width: "50%",
    float: "right" as "right",
    textAlign: "right" as "right",
    height: "50px",
    fontSize: "15px",
    lineHeight: "50px",
    color: "#575757",
  },
  certModalContent: {
    width: "292px",
    height: "fit-content",
    position: "absolute",
    top: "50%",
    backgroundColor: "unset",
    borderRadius: "8px",
    left: "50%",
    transform: "translate(-50%,-50%)",
  },
  certModal: {
    width: "100%",
    height: "fit-content",
    position: "relative" as "relative",
  },
  popCertImg: {
    width: "100%",
    display: "block",
    borderRadius: "8px",
  },
  certHead: {
    position: "relative" as "relative",
  },
  certDownload: {
    width: "100%",
    height: "fit-content",
    // paddingBottom: "100px",
  },
  closeBtn: {
    position: "absolute" as "absolute",
    top: "6px",
    right: "6px",
    width: "24px",
    height: "24px",
    zIndex: 10,
  },
  closeBtnImg: {
    width: "100%",
    height: "100%",
  },
  popCertPoster: {
    width: "100%",
    borderRadius: "8px",
    verticalAlign: "top",
  },
  certNickContainer: {
    width: "100%",
    position: "absolute" as "absolute",
    left: "50%",
    top: "0",
    transform: "translate(-50%,0)",
    paddingTop: "20px",
    boxSizing: "border-box" as "border-box",
  },
  certPortrait: {
    display: "block",
    width: "25px",
    height: "25px",
    borderRadius: "50%",
    margin: "0 auto 4px",
  },
  certNick: {
    fontSize: "12px",
    color: "#222",
    textAlign: "center" as "center",
    width: "100%",
    lineHeight: "16px",
  },
  certSlogan: {
    color: "#00BC71",
    fontSize: "16px",
    fontWeight: "bold" as "bold",
    marginTop: "10px",
    textAlign: "center" as "center",
    lineHeight: "23px",
    letterSpacing: "1px",
  },
  certDesc: {
    fontSize: "12px",
    color: "#222222",
    marginTop: "218px",
    fontWeight: 500,
    textAlign: "center" as "center",
    lineHeight: "16px",
  },
  nameContainer: {
    width: "252px",
    height: "48px",
    textAlign: "center" as "center",
    lineHeight: "48px",
    position: "relative" as "relative",
    margin: "20px auto 0",
  },
  nameImg: {
    width: "100%",
    height: "100%",
  },
  nameTag: {
    fontSize: "12px",
    color: "#00BC71",
    fontWeight: 500,
    display: "block",
    height: "20px",
    lineHeight: "20px",
    textAlign: "center" as "center",
    width: "135px",
    position: "absolute" as "absolute",
    top: "-10px",
    left: "50%",
    transform: "translate(-50%,0)",
  },
  actName: {
    fontSize: "16px",
    color: "#00BC71",
    fontWeight: 500,
    width: "100%",
    whiteSpace: "nowrap" as "nowrap",
    textOverflow: "ellipsis",
    position: "absolute" as "absolute",
    top: "0",
    left: "50%",
    transform: "translate(-50%,0)",
    overflow: "hidden",
    padding: "0 10px",
  },
  certButtonContainer: {
    padding: "0 26px",
    marginTop: "20px",
    boxSizing: "border-box" as "border-box",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  certButton: {
    width: "110px",
    height: "45px",
    borderRadius: "23px",
    backgroundColor: "#00BC71",
    fontSize: "16px",
    fontWeight: 500,
    color: "#fff",
    textAlign: "center" as "center",
    lineHeight: "45px",
  },
  routeIcon: {
    width: "12px",
    height: "12px",
    verticalAlign: "middle",
    marginRight: "7px",
  },
  sportTime: {
    fontSize: "12px",
    color: "#7a7a7a",
  },
  routeTimeItem: {
    marginRight: "15px",
  },

  rewardItem: {
    position: "relative" as "relative",
  },
  rewardPic: {
    width: "80px",
    height: "80px",
    display: "block",
    float: "left" as "left",
  },
  rewardContainer: {
    marginTop: "15px",
  },
  rewardTitleContainer: {
    height: "85px",
    width: "180px",
    marginLeft: "20px",
    float: "left" as "left",
  },
  rewardTitle: {
    fontSize: "14px",
    fontWeight: 600,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as "nowrap",
    color: "#222",
    marginBottom: "10px",
    marginTop: "16px",
  },
  rewardSubtitle: {
    fontSize: "12px",
    color: "#999",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as "nowrap",
  },
};
